<script>
  import DynamicHeading from "../../atoms/DynamicHeading.svelte";

  // @ts-check
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";
  import Grid from "../../atoms/Grid.svelte";
  import GridContainer from "../../atoms/GridContainer.svelte";

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = undefined;

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Array of objects containing a question and answer
   * @type {ItemsType[]}
   */
  export let items = [];

  const pseudoElement =
    "before:absolute lg:before:flex lg:before:justify-center before:w-grid-gutter md:before:-left-grid-gutter before:-top-10 md:before:top-0 before:heading-xs before:h-10 md:before:h-auto";
</script>

<DynamicHeadingContext>
  <GridContainer>
    <Grid {id}>
      <ul
        class="col-full-width md:col-start-3 md:col-end-11 lg:col-start-4 lg:col-end-10 {className}"
      >
        {#each items as { question, answer }}
          <li class="pb-7.5 last-of-type:pb-0 md:pb-15 lg:pb-20">
            <DynamicHeading
              class="body-md relative mb-6 mt-10 font-bold before:content-['Q'] md:mt-0 lg:mb-8 xl:mb-10 {pseudoElement}"
            >
              {question}
            </DynamicHeading>
            <div class="body-md relative mt-[4rem] before:content-['A'] md:mt-0 {pseudoElement}">
              {#if answer.bodyProps}
                <svelte:component this={answer.body} {...answer.bodyProps} />
              {:else}
                <p>{answer.body}</p>
              {/if}
            </div>
          </li>
        {/each}
      </ul>
    </Grid>
  </GridContainer>
</DynamicHeadingContext>
